import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export const months = [
    { name: 'Ocak', value: 1 },
    { name: 'Şubat', value: 2 },
    { name: 'Mart', value: 3 },
    { name: 'Nisan', value: 4 },
    { name: 'Mayıs', value: 5 },
    { name: 'Haziran', value: 6 },
    { name: 'Temmuz', value: 7 },
    { name: 'Ağustos', value: 8 },
    { name: 'Eylül', value: 9 },
    { name: 'Ekim', value: 10 },
    { name: 'Kasım', value: 11 },
    { name: 'Aralık', value: 12 },
];

export const MonthFilter = ({ item, applyValue }: { item: any, applyValue: any }) => {
    const handleChange = (event: any) => {
        const value = event.target.value === '' ? null : Number(event.target.value);
        applyValue({ ...item, value });
    };

    return (
        <FormControl fullWidth sx={{ minWidth: 120 }}>
            <InputLabel id="month-filter-label">Ay</InputLabel>
            <Select
                labelId="month-filter-label"
                id="month-filter"
                value={item.value ?? ''}
                label="Ay"
                onChange={handleChange}
            >
                <MenuItem value="">
                    <em>Tümü</em>
                </MenuItem>
                {months.map((month) => (
                    <MenuItem key={month.value} value={month.value}>
                        {month.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export const monthFilterOperator = {
    label: 'is',
    value: 'is',
    InputComponent: MonthFilter,
    getApplyFilterFn: (filterItem: any) => {
        if (!filterItem.value) {
            return null;
        }
        return (value: any) => {
            return Number(value) === Number(filterItem.value);
        };
    },
};